var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.5815 1.29396C26.4946 1.29396 1.29379 26.4948 1.2938 57.5816C1.2938 88.6685 26.4947 113.869 57.5815 113.869C88.6683 113.869 113.869 88.6684 113.869 57.5816C113.869 26.4948 88.6683 1.29396 57.5815 1.29396Z",
    stroke: "#34FA77",
    strokeWidth: 2.58794
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5819 9.53115C31.0443 9.53115 9.53141 31.0441 9.53141 57.5816C9.53142 84.1191 31.0443 105.632 57.5819 105.632C84.1194 105.632 105.632 84.1191 105.632 57.5816C105.632 31.0441 84.1194 9.53115 57.5819 9.53115Z",
    fill: "#34FA77"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6838 44.18L49.1212 72.3238L36.1382 59.5311",
    stroke: "white",
    strokeWidth: 4.15457,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick2);
export default __webpack_public_path__ + "static/media/greenTick2.7d02a01b4174f9b4b45b3ac965facb30.svg";
export { ForwardRef as ReactComponent };